import {
  Instagram, Facebook, Twitter, Youtube, Send, Globe, ShoppingBag,
  Heart, UserPlus, Star, MessageCircle, Play, Share2,
  Users, Palette, Camera, Smile, Briefcase
} from 'lucide-react';

// Visual identity per platform, kept in one place so task cards,
// review rows and history rows all read the same way.
export const PLATFORM_META = {
  instagram: { label: 'Instagram', Icon: Instagram, tint: 'bg-gradient-to-br from-fuchsia-500 to-amber-400' },
  facebook: { label: 'Facebook', Icon: Facebook, tint: 'bg-[#1877F2]' },
  tiktok: { label: 'TikTok', Icon: MusicNoteIcon, tint: 'bg-[#111827]' },
  youtube: { label: 'YouTube', Icon: Youtube, tint: 'bg-[#FF0000]' },
  telegram: { label: 'Telegram', Icon: Send, tint: 'bg-[#229ED9]' },
  x: { label: 'X', Icon: Twitter, tint: 'bg-black' },
  google: { label: 'Google', Icon: Globe, tint: 'bg-[#4285F4]' },
  shopping: { label: 'Store', Icon: ShoppingBag, tint: 'bg-brand-600' }
};

// TikTok has no lucide brand icon, so a small inline glyph keeps the tile set consistent.
function MusicNoteIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M9 18V5l12-2v13" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="18" cy="16" r="3" />
    </svg>
  );
}

// img = sticker artwork supplied for the /don-hang boards; components render
// the PNG when present and fall back to the lucide Icon otherwise.
export const ACTION_META = {
  like: { Icon: Heart, verbKey: 'taskVerbLike', img: '/images/actions/like.png' },
  follow: { Icon: UserPlus, verbKey: 'taskVerbFollow', img: '/images/actions/follow.png' },
  subscribe: { Icon: Play, verbKey: 'taskVerbSubscribe', img: '/images/actions/subscribe.png' },
  review: { Icon: Star, verbKey: 'taskVerbReview', img: '/images/actions/favorite.png' },
  comment: { Icon: MessageCircle, verbKey: 'taskVerbComment', img: '/images/actions/comment.png' },
  join: { Icon: UserPlus, verbKey: 'taskVerbJoin' },
  share: { Icon: Share2, verbKey: 'taskVerbShare' }
};

export const getPlatformMeta = (platform) =>
  PLATFORM_META[platform] || { label: platform, Icon: Globe, tint: 'bg-ink-muted' };

export const getActionMeta = (actionType) =>
  ACTION_META[actionType] || { Icon: Heart, verbKey: 'taskVerbLike' };

// GetLike's market shows a circular category rail; tints follow its bright flat palette.
export const CATEGORY_META = {
  Friends: { Icon: Users, tint: 'bg-[#2A96F1]' },
  Hobbies: { Icon: Palette, tint: 'bg-[#F0842A]' },
  Photography: { Icon: Camera, tint: 'bg-[#8E5AF7]' },
  Beauty: { Icon: Smile, tint: 'bg-[#F0497E]' },
  Business: { Icon: Briefcase, tint: 'bg-[#12A594]' }
};

export const getCategoryMeta = (name) =>
  CATEGORY_META[name] || { Icon: Users, tint: 'bg-[#9AA0A6]' };

export const formatMoney = (amount) => {
  const value = Number(amount || 0);
  const isWhole = value % 1 === 0;
  return `$${new Intl.NumberFormat('en-US', {
    minimumFractionDigits: isWhole ? 0 : 2,
    maximumFractionDigits: isWhole ? 0 : 2
  }).format(value)}`;
};
